import { GET_APPROVAL_FLOW_LIST,GET_APPROVAL_FLOW_BY_ID,UPDATE_APPROVAL_FLOW,UPDATE_STAGES,UPDATE_DOCUMENTS,ADD_APPPROVAL_WORK_FLOW,ADD_DOCUMENTS,ADD_ORIGINATORS,ADD_STAGES,APPROVER_ACTION,GET_ALL_USERS_BY_ROLE_ID,GET_APPROVAL_ACCEPTANCE,GET_APPROVAL_LIST,GET_COLUMNS,GET_MAIN_MODULES,GET_SUB_MODULES } from "../types";

export const addApprovalWorkFlowAction = (data,onSuccess, onError) => {
  return {
    type: ADD_APPPROVAL_WORK_FLOW,
    data,
    onSuccess,
    onError,
  };
};

export const getUserByRoleIdAction = (data,onSuccess, onError) => {
  return {
    type: GET_ALL_USERS_BY_ROLE_ID,
    data,
    onSuccess,
    onError,
  };
};

export const addOriginatorsAction = (data,onSuccess, onError) => {
  return {
    type: ADD_ORIGINATORS,
    data,
    onSuccess,
    onError,
  };
};

export const getMainModulesAction = (data,onSuccess,onError) =>{
  return{
    type: GET_MAIN_MODULES,
    data,
    onSuccess,
    onError
  }
}

export const getSubModulesAction = (data,onSuccess,onError) =>{
  return{
    type: GET_SUB_MODULES,
    data,
    onSuccess,
    onError
  }
}

export const getColumnsAction = (data,onSuccess,onError) =>{
  return{
    type: GET_COLUMNS,
    data,
    onSuccess,
    onError
  }
}

export const addDocumentsAction = (data,onSuccess,onError) =>{
  return{
  type: ADD_DOCUMENTS,
    data,
    onSuccess,
    onError
  }
}

export const addStagesAction = (data,onSuccess,onError) =>{
  return{
    type: ADD_STAGES,
    data,
    onSuccess,
    onError
  }
}

export const getApprovalListAction = (data,onSuccess,onError) =>{
  return{
    type: GET_APPROVAL_LIST,
    data,
    onSuccess,
    onError
  }
}

export const getApprovalAcceptanceAction = (data,onSuccess,onError) =>{
  return{
    type: GET_APPROVAL_ACCEPTANCE,
    data,
    onSuccess,
    onError
  }
}

export const approverActionAction = (data,onSuccess,onError) =>{
  return{
    type: APPROVER_ACTION,
    data,
    onSuccess,
    onError
  }
}
export const getApprovalFlowByIdAction = (data, onSuccess, onError) => {
  return {
    type: GET_APPROVAL_FLOW_BY_ID,
    data,
    onSuccess,
    onError,
  };
};

export const updateApprovalFlowAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_APPROVAL_FLOW,
    data,
    onSuccess,
    onError,
  };
};

export const updateStagesAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_STAGES,
    data,
    onSuccess,
    onError,
  };
};

export const updateDocumentsAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_DOCUMENTS,
    data,
    onSuccess,
    onError,
  };
};

export const getApprovalFlowListAction = (data, onSuccess, onError) => {
  return {
    type: GET_APPROVAL_FLOW_LIST,
    data,
    onSuccess,
    onError,
  };
};
